import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BaseResizableComponent } from '@src/app/modules/base';
import { NavigationItem, ADMINISTRATION_NAVIGATION } from '@src/app/modules/navigation';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdministrationComponent extends BaseResizableComponent {
  private readonly router = inject(Router);

  selectedItem?: NavigationItem;

  readonly navTree = ADMINISTRATION_NAVIGATION;

  get showFullPage(): boolean {
    return !this.selectedItem || this.isLargeScreen;
  }

  onClickReturnButton() {
    this.selectedItem = undefined;
    this.router.navigate(['settings/administration']);
  }
}
